import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * Lovable's SPA hosting serves index.html with HTTP 200 for unknown paths,
 * so we can't return a real 404/410 status from the client. The next-best
 * signal for Googlebot is a "soft-404 fix" head:
 *
 *  - <meta name="robots" content="noindex, follow"> — tells Google to drop
 *    the URL from the index (handles "Soft 404" and "Duplicate, Google chose
 *    different canonical" reports for non-existent routes).
 *  - <meta name="prerender-status-code" content="404"> — honored by
 *    prerender.io / rendertron-style services to emit a real 404 to crawlers.
 *  - No <link rel="canonical"> — never self-canonicalize a 404.
 *  - <title> prefixed with "404 –" so it's obvious in SERPs if any leak.
 */
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 – Page not found | Ethio Real Estates</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex, follow" />
        <meta name="prerender-status-code" content="404" />
        <meta name="description" content="The page you requested does not exist on Ethio Real Estates." />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
